import React from "react";

interface FooterLinksProps {
  className?: string;
}

const FooterLinks: React.FC<FooterLinksProps> = ({ className }) => {
  const aideLinks = [
    { label: "Centre d'assistance (bonne chance)", href: "#" },
    { label: "Politique de vie privée", href: "#" },
    { label: "Conditions d'utilisation", href: "#" },
    { label: "Code d'éthique de l'IA (LOL)", href: "#" },
    { label: "Accessibilité et accommodation", href: "#" },
    { label: "Gérer mon consentement", href: "#" },
    { label: "Carrières (on embauche!)", href: "#" },
    { label: "Annoncez avec nous", href: "#" },
    { label: "À propos de nous", href: "#" },
  ];

  const outilsLinks = [
    { label: "API météo (vraiment approximative)", href: "#" },
    { label: "Application Android", href: "#" },
    { label: "Application iOS", href: "#" },
    { label: "Applis télé", href: "#" },
  ];

  const partnerLinks = [
    { label: "The Weather Network", href: "#" },
    { label: "Pelmorex Corp", href: "#" },
    { label: "ElTiempo", href: "#" },
    { label: "Clima", href: "#" },
    { label: "En Alerte", href: "#" },
  ];

  return (
    <div className={`grid gap-8 sm:grid-cols-2 lg:grid-cols-3 ${className || ""}`}>
      <div>
        <h3 className="mb-4 font-semibold text-white">Aide</h3>
        <ul className="space-y-2">
          {aideLinks.map((link, index) => (
            <li key={index}>
              <a
                href={link.href}
                className="text-sm text-gray-400 hover:text-meteoyellow-500"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="mb-4 font-semibold text-white">Outils météo</h3>
        <ul className="space-y-2">
          {outilsLinks.map((link, index) => (
            <li key={index}>
              <a
                href={link.href}
                className="text-sm text-gray-400 hover:text-meteoyellow-500"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <hr className="mb-4 border-gray-700 lg:hidden" />
        <ul className="space-y-2">
          {partnerLinks.map((link, index) => (
            <li key={index}>
              <a
                href={link.href}
                className="text-sm text-gray-400 hover:text-meteoyellow-500"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FooterLinks;
